import POPUP_TPL from '../../resources/handlebars/components/generic-modal.hbs';

export class GenericModal {
    constructor({title, message, confirmLabel, cancelLabel, notabene, illustration}) {
        this.id = `confirmPopup_${new Date().getTime()}`;

        const modalMarkup = POPUP_TPL({
            confirmLabel,
            cancelLabel,
            id: this.id,
            confirmTitle: title,
            confirmMessage: message,
            illustration,
            notabene,
        });

        $('body').append(modalMarkup);
        this.popup = $(`#${this.id}`);
    }

    show(callback) {
        this.popup.modal('show');
        this.popup.find('[data-confirm]').click((e) => {
            e.preventDefault();
            if (callback.length === 2) {
                $(this).addClass('loading');
                callback(true, () => this.popup.modal('hide'));
            } else {
                this.popup.modal('hide');
                callback(true);
            }
        });
    }
}

export function blackListedCountryModal() {
    return new GenericModal({
        title: Hop.message('company.coords.warning.blacklisted.countries.title'),
        message: Hop.message('company.coords.warning.blacklisted.countries.content'),
        confirmLabel: Hop.message('company.coords.warning.blacklisted.countries.button'),
        illustration: '//dam.malt.com/company/bank_fail_ico',
    });
}
